import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import {
  CreateWorksheetResponse,
  WorksheetDetail,
  WorksheetList,
  WorksheetSearch,
} from '../interfaces/worksheet.model';

@Injectable({ providedIn: 'root' })
export class WorksheetsService {
  constructor(private http: HttpClient) {}

  getWorksheetList(page: number, pageSize: number, filter: WorksheetSearch): Observable<WorksheetList> {
    return this.http.post<WorksheetList>('api/incassi/brogliacci/list', filter, {
      params: { page, pagesize: pageSize },
    });
  }

  getWorksheetDetail(idWorksheet: string): Observable<WorksheetDetail | null> {
    return this.http
      .get<WorksheetDetail>(`api/incassi/brogliacci/${idWorksheet}`)
      .pipe(map(detail => (!detail?.id || detail.numeroBrogliaccio === 0 ? null : detail)));
  }

  createWorksheet(idIncassi: string[]): Observable<string | null> {
    return this.http
      .post<CreateWorksheetResponse>('api/incassi/brogliacci/crea', { incassoIds: idIncassi })
      .pipe(map(response => response?.idBrogliaccio ?? null));
  }

  confirmWorksheet(idWorksheet: string): Observable<void> {
    return this.http.put<void>(`api/incassi/brogliacci/${idWorksheet}/conferma`, {});
  }

  deleteWorksheet(idWorksheet: string): Observable<void> {
    return this.http.delete<void>(`api/incassi/brogliacci/${idWorksheet}`);
  }

  downloadWorksheetPdf(idWorksheet: string): Observable<Blob> {
    return this.http.get(`api/Incassi/Stampe/brogliaccio/${idWorksheet}`, {
      responseType: 'blob',
    });
  }
}
